import React from 'react';

export const SkeletonRow: React.FC<{ cols: number }> = ({ cols }) => (
  <tr className="animate-pulse" data-testid="item-skeleton-row">
    {Array.from({ length: cols }).map((_, i) => (
      <td key={i} className="py-4 px-4">
        <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-full" />
      </td>
    ))}
  </tr>
); 
// COMMENT